// Function definitions
const _mapCustomer = function (customer){
    if(customer.billing_address){
        for(let index in customer.billing_address){
            if(customer.billing_address.hasOwnProperty(index) && index !== 'id'){
                customer[index] = customer.billing_address[index];
            }
        }
    }
    delete(customer.billing_address);
    return customer;
};

const search = function(params = {}){
    return new Promise((fulfill, reject) => {
        window.axios.get('/api/customers', {
            params: params,
        }).then(xhr => {
            let customers = [];
            for (let index in xhr.data.data){
                customers.push(_mapCustomer(xhr.data.data[index]));
            }
            xhr.data.data = customers;
            fulfill(xhr);
        }, error => {
            reject(error);
        })
    });
};

const get = function(id){
    return new Promise((fulfill, reject) => {
        window.axios.get('/api/customers/'+id).then(xhr => {
            xhr.data = _mapCustomer(xhr.data);
            fulfill(xhr);
        }, error => {
            reject(error);
        });
    });
};

const payloadFor = function (customer) {
    return {
        company_name: customer.company_name,
        account_ref: customer.account_ref,
        billing_name: customer.billing_name,
        billing_email: customer.billing_email,
        billing_telephone: customer.billing_telephone,
        billing_address_id: customer.billing_address_id || null,
        responsible_person_name: customer.responsible_person_name,
        responsible_person_email: customer.responsible_person_email,
        responsible_person_telephone: customer.responsible_person_telephone,
        response_time_hours: customer.response_time_hours,
        overdue: customer.overdue ? true : false,
        proforma: customer.proforma ? true : false,
        address_line_1: customer.address_line_1,
        address_line_2: customer.address_line_2,
        address_line_3: customer.address_line_3,
        town: customer.town,
        region: customer.region,
        country: customer.country,
        postcode: customer.postcode,
        lat: customer.lat,
        lng: customer.lng,
        w3w: customer.w3w || null,
    };
};

const create = function(customer){
    return window.axios.post('/api/customers', payloadFor(customer));
};

const update = function(customer){
    return window.axios.put('/api/customers/'+customer.id, payloadFor(customer));
};

const deleteCustomer = function(customer){
    return window.axios.delete('/api/customers/'+customer.id, customer);
};

const jobs = function(customer){
    return window.axios.get('/api/customers/'+customer.id+'/jobs');
};

const forms = function(customer){
    return window.axios.get('/api/customers/'+customer.id+'/forms');
};

export default {
    search,
    get,
    create,
    update,
    delete: deleteCustomer,
    jobs,
    forms,
    _mapCustomer,
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/CustomerService.js